import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

const TestBox = styled(Box)(() => ({}));

const ProjectClaim = (): JSX.Element => {
  return (
    <>
      <Box sx={{ width: '100%' }}>
        <TestBox>
          claim
        </TestBox>
      </Box>
    </>
  );
}

export default ProjectClaim;
